import { supabase } from '../supabaseClient';

export const checkAdminStatus = async () => {
  try {
    const { data, error } = await supabase.rpc('is_admin_user');
    if (error) {
      console.error('Error checking admin status:', error);
      return false;
    }
    return data;
  } catch (err) {
    console.error('Error checking admin status:', err);
    return false;
  }
};

export const getCurrentUserProfile = async () => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return null;

    const { data, error } = await supabase
      .from('user_profiles')
      .select('*')
      .eq('user_id', user.id)
      .single();

    if (error) {
      console.error('Error getting user profile:', error);
      return null;
    }

    return { ...data, auth_user: user };
  } catch (err) {
    console.error('Error getting current user profile:', err);
    return null;
  }
};
